import { type ReactNode } from 'react';
import { Outlet } from 'react-router';
import useIsOnline from '@/hooks/useIsOnline';
import useGiftPhotoRefresh from '@/hooks/useGiftPhotoRefresh';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertTriangleIcon } from 'lucide-react';

type LayoutProps = {
  children?: ReactNode;
};

function Layout({ children }: LayoutProps) {
  const isOnline = useIsOnline();
  // Every route, because only the landing page fetches the gift and the
  // signed photo URL dies an hour after it is issued.
  useGiftPhotoRefresh();
  return (
    <div className='main-wrapper min-h-screen text-center lg:text-left'>
      {!isOnline && (
        <Alert className='border-amber-200 bg-amber-50  dark:border-amber-900 dark:bg-amber-950 dark:text-amber-50 sticky top-0 z-50'>
          <AlertTriangleIcon />
          <AlertTitle className='text-left'>You are currently offline.</AlertTitle>
          <AlertDescription>
            <p>Please check your internet connection.</p>
          </AlertDescription>
        </Alert>
      )}
      <Outlet />
      {children}
    </div>
  );
}

export default Layout;
